var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "passenger-feedback-carousel-wrapper" },
    [
      _c("a", { staticClass: "page-link", on: { click: _vm.prevItem } }, [
        _c("img", {
          attrs: { src: "/imgs/icons/passenger-feedback-arrow-left.webp" }
        })
      ]),
      _vm._v(" "),
      _c(
        "carousel",
        {
          attrs: {
            autoplay: _vm.autoplay,
            "autoplay-hover-pause": "",
            "per-page": 1,
            "pagination-enabled": false,
            "autoplay-timeout": 3000,
            "center-mode": "",
            loop: "",
            "navigate-to": _vm.index
          },
          on: {
            input: function($event) {
              _vm.index = !!$event ? $event : _vm.index
            }
          }
        },
        _vm._l(_vm.entries, function(entry, index) {
          return _c("slide", { key: index }, [
            _c("div", { staticClass: "passenger-feedback-carousel-item" }, [
              _vm._v("\n                “"),
              _c("span", { domProps: { innerHTML: _vm._s(entry.html_text) } }),
              _vm._v("”\n            ")
            ])
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c("a", { staticClass: "page-link", on: { click: _vm.nextItem } }, [
        _c("img", {
          attrs: { src: "/imgs/icons/passenger-feedback-arrow-right.webp" }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-076f2718", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-076f2718","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PassengerFeedbackCarousel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-076f2718","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PassengerFeedbackCarousel.vue
// module chunks = 1 2 3